import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Input from "ui/input";

import styles from "./index.module.scss";

interface Props {
	initValue: string;
}

const search = async function (value: string): Promise<void> {
	const url = new URL(window.location.href);
	url.searchParams.set("q", encodeURIComponent(value));
	window.location.assign(url.href);
}

export const SearchInput = function ({ initValue }: Props) {
	const [value, setValue] = useState(initValue);
	const [show, setShow] = useState(false);
	return <div className={ styles.container }>
		<div className={ styles.searchBar }>
			<div className={ styles.input }>
				<Input
					value={ value }
					onChange={ v => setValue(v) }
					placeholder="Search fangames..."
					onEnter={ () => search(value).catch(console.error) }
				/>
			</div>
			<div className={ styles.actions }>
				<button
					type="button"
					className={ styles.searchBtn }
					onClick={ () => search(value).catch(console.error) }
				>
					Search
				</button>
				<button
					type="button"
					className={ styles.fullListBtn }
					onClick={ () => search("*").catch(console.error) }
				>
					Full list
				</button>
				<button
					type="button"
					className={ styles.helpBtn }
					onClick={ () => setShow(!show) }
					title="Search tips"
				>
					<FontAwesomeIcon icon={ faQuestionCircle } />
				</button>
			</div>
		</div>
		<div
			className={ styles.help }
			custom-hidden={ (!show).toString() }
		>
			<div>To get the full list, type <span>*</span></div>
			<div>You can insert double quotes around a phrase to force exact matches.</div>
			<div>To improve the search experience, the following words are ignored: {
				["i", "wanna", "be", "the"]
				.map((word, i) => <span key={ i }>{ i === 0 ? "" : ", " }{ word }</span>)
			}</div>
		</div>
	</div>;
};
